var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"link","size":"sm","icon":"icon-download-outline"},on:{"click":_vm.onexport}},[_vm._v("Exportar a Excel")])
}
var staticRenderFns = []

export { render, staticRenderFns }